import {makeObservable} from 'mobx';

import type {Nullable} from '../../../../utils/utility-types';
import type {DateTimeModel} from '../../Date/DateTime.model';

import {BaseModel} from '../../Base/Base.model';

const ModelName = 'UserOnboardingModel';

export class UserOnboardingModel extends BaseModel {
  answers: UserOnboardingModel.Answer[] = [];
  finished: Nullable<DateTimeModel> = null;
  type: UserOnboardingModel.Type = 'internal';

  constructor(props: UserOnboardingModel.Props) {
    super({id: ''});
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<
        UserOnboardingModel,
        UserOnboardingModel.Props
      >(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace UserOnboardingModel {
  export type Answer = {
    answer: string[];
    question: string;
  };

  export type Props = BaseModel.ModelToProps<UserOnboardingModel, 'id'>;

  export type Type = 'b2b_widget' | 'external' | 'internal' | 'tenant_manager';

  export const HOW_DID_YOU_HEAR_ABOUT_US_QUESTION =
    'how_did_you_hear_about_us' as const;
}
